var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(0.37)",
    opacity: 0.398
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    d: "M16,2A14,14,0,0,0,6.1,25.9,14,14,0,0,0,25.9,6.1,13.908,13.908,0,0,0,16,2m0-2A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(-0.37)",
    fill: "#004a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_113",
    "data-name": "Rechteck 113",
    width: 2,
    height: 11,
    transform: "translate(14.63 14)",
    fill: "#004a5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(13.63 7)",
    fill: "#004a5a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b3bf69939842ee78be2026d3bdf96847.svg";
export { ForwardRef as ReactComponent };